import React from 'react'
import { connect } from 'react-redux'
import store from '../store'
import { RouteComponentProps } from 'react-router-dom'
import { makeStyles, Theme } from '@material-ui/core/styles'

import { CssBaseline, Container, Grid } from '@material-ui/core'
import LoadingOverlay from 'react-loading-overlay'
import DefaultToolbar from '../components/organisms/DefaultToolbar'
import { Route, Switch } from 'react-router-dom'
import Notifications from '../pages/Notifications'
import PushHistory from '../pages/PushHistory'
import NotificationCMS from '../pages/NotificationCMS'
import Events from '../pages/Events'
import EventCMS from '../pages/EventCMS'
import Users from '../pages/Users'
// import UserDetail from '../pages/UserDetail'
import Messages from '../pages/Messages'
import MessageHistory from '../pages/MessageHistory'
import ContactCMS from '../pages/ContactCMS'
import BannerCMS from '../pages/BannerCMS'
import SocietyInfo from '../pages/SocietyInfo'
import SocietyInfoCMS from '../pages/SocietyInfoCMS'
import Admins from '../pages/Admins'
import AdminCMS from '../pages/AdminCMS'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex'
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto'
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4)
  },
  loadingOverlay: {
    height: '100%'
  }
}))

const DefaultLayout: React.FC<RouteComponentProps & ReturnType<typeof mapStateToProps>> = ({
  loading
}) => {
  const classes = useStyles({})

  return (
    <div className={classes.root}>
      <CssBaseline />
      <DefaultToolbar />
      <main id="main-content" className={classes.content}>
        <LoadingOverlay
          active={loading}
          spinner
          className={classes.loadingOverlay}
          styles={{
            overlay: base => ({
              ...base,
              background: 'rgba(255, 255, 255)',
              opacity: 0.4,
              position: 'fixed',
              zIndex: 10000
            }),
            spinner: base => ({
              ...base,
              width: '100px',
              '& svg circle': {
                stroke: '#3f51b5'
              }
            })
          }}
        >
          <div className={classes.appBarSpacer} />
          <Container maxWidth="xl" className={classes.container}>
            <Grid container spacing={1}>
              <Switch>
                <Route exact path="/" component={Notifications} />
                <Route exact path="/push-history" component={PushHistory} />
                <Route exact path="/create-notification" component={NotificationCMS} />
                <Route
                  exact
                  path="/edit-notification/:notification_id"
                  component={NotificationCMS}
                />
                <Route exact path="/users" component={Users} />
                {/* <Route exact path="/user-detail" component={UserDetail} /> */}
                <Route exact path="/messages" component={Messages} />
                <Route exact path="/message-history/:kaiin_no" component={MessageHistory} />
                <Route exact path="/events" component={Events} />
                <Route exact path="/create-event" component={EventCMS} />
                <Route exact path="/edit-event/:event_id" component={EventCMS} />
                <Route exact path="/society-info" component={SocietyInfo} />
                <Route exact path="/create-society-info" component={SocietyInfoCMS} />
                <Route
                  exact
                  path="/edit-society-info/:society_info_id"
                  component={SocietyInfoCMS}
                />
                <Route exact path="/contact" component={ContactCMS} />
                <Route exact path="/banner" component={BannerCMS} />
                <Route exact path="/admins" component={Admins} />
                <Route exact path="/edit-admin/:admin_id" component={AdminCMS} />
                <Route exact path="/create-admin" component={AdminCMS} />
                <Route exact path="/env">
                  <pre>{JSON.stringify(process.env, null, '  ')}</pre>
                </Route>
              </Switch>
            </Grid>
          </Container>
        </LoadingOverlay>
      </main>
    </div>
  )
}

const mapStateToProps = (state: ReturnType<typeof store.getState>) => {
  // 上のApp変数のpropsに下のreturn
  // で返ってくるオブジェクトが入る
  return {
    loading: state.loading.loading
  }
}

export default connect(mapStateToProps, null)(DefaultLayout)
